import tm90_headerbg from "@assets/tm90/tm90_headerbg.svg";
import tm90_logo from "@assets/tm90/tm90_logo.svg";
import { SocialMedia } from "@header/TopHeader/TopSocialMedia";
import { ReactElement } from "react";

import { Tm90HeaderMenues } from "./Tm90HeaderMenues";

// Header Component
const Tm90Header = (): ReactElement => {
  return (
    <>
      <div className="w-full bg-gray-500">
        <div className="lg:max-w-lg xl:max-w-xl w-full mx-auto lg:px-sm h-xxm">
          <div className="lg:mt-1 hidden lg:inline-block md:inline-block">
            <SocialMedia testId={"tm90_header"} />
          </div>
          <div className="float-right lg:px-sm inline-flex font-primary">
            <Tm90HeaderMenues />
          </div>
        </div>
      </div>
      <div className="bg-black-100 relative overflow-hidden  min-h-[550px] lg:min-h-[780px] w-full">
        {/* Background newspaper pattern with actual newspaper images */}
        <div className="absolute inset-0 opacity-30 lg:px-100">
          <div
            className="mt-[-30px] bg-no-repeat bg-[center_top] bg-cover w-full h-full min-h-[810px]"
            style={{ backgroundImage: `url('${tm90_headerbg}')` }}
          >
            &nbsp;
          </div>
        </div>

        {/* Dark overlay for better text readability */}
        <div className="absolute inset-0 bg-black-100 bg-opacity-25"></div>

        {/* Main header content */}
        <div className="relative z-10 text-center flex flex-col items-center justify-center h-full min-h-[550px] lg:min-h-[780px] ">
          {/* Logo Image */}
          <img
            alt="toggle-button-chevie"
            height={374}
            width={378}
            className="inline w-[233px] lg:w-[378px]"
            src={tm90_logo}
          />
        </div>
      </div>
    </>
  );
};

export default Tm90Header;
